import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AgreementReceipt from '../../../agreementReceipt.jsx';
import Page from '../../../page.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import paymentPropTypes from '../../../paymentPropTypes.js';
import { formatDate } from '../../../getDeadline.js';

const Pay = ({ agreement, payment, partner, handleClickPay }) => (
    <Page heading="Betal til FINN">
        <div>
            <p>
                {partner.name} har godkjent avtalen. Du betaler til oss, og vi
                passer på pengene til du har fått og godkjent varen.
            </p>

            <p>
                Betalingsfristen er{' '}
                <span className="strong">
                    {formatDate(agreement.paymentDeadline)}
                </span>.
            </p>

            <div className="r-phl r-pbl">
                <AgreementReceipt
                    agreement={agreement}
                    partner={partner}
                    role="BUYER"
                />
            </div>

            <div className="r-phl r-ptl">
                <button
                    disabled={payment.loading}
                    onClick={handleClickPay}
                    className={classNames('order fullwidth', {
                        inprogress: payment.loading,
                    })}
                >
                    Betal
                </button>
            </div>
        </div>
    </Page>
);

Pay.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    handleClickPay: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

export default Pay;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/pay.jsx